// Client configuration constants
export const CLIENT_APP_VERSION = process.env.REACT_APP_CLIENT_VERSION || "2.3.0";
